/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleExecutionNotificationWebhook {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    constructor() {
        this.setDiscriminator("ScheduleExecutionNotificationWebhook");
    }

    getFixupPrototypeFunction() { return ScheduleExecutionNotificationWebhook.fixupPrototype; }

    static newInstance(model: Partial<ScheduleExecutionNotificationWebhook>): ScheduleExecutionNotificationWebhook {
        let obj = Object.assign(new ScheduleExecutionNotificationWebhook(), model);
        ScheduleExecutionNotificationWebhook.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleExecutionNotificationWebhook>): ScheduleExecutionNotificationWebhook {
        if (!model) return null;
        return ScheduleExecutionNotificationWebhook.newInstance(<ScheduleExecutionNotificationWebhook> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleExecutionNotificationWebhook) {
        if (!obj) return;

        models.ScheduleExecutionNotificationWebhook.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleExecutionNotificationWebhook): boolean {
        switch (obj.__type)
        {
            case "ScheduleExecutionNotificationWebhook":
                Object.setPrototypeOf(obj, ScheduleExecutionNotificationWebhook.prototype);
                break;
            case "ScheduleExecutionNotificationWebHookForStandardType":
                Object.setPrototypeOf(obj, models.ScheduleExecutionNotificationWebHookForStandardType.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof ScheduleExecutionNotificationWebhook)[] {
        return [
            models.ScheduleExecutionNotificationWebHookForStandardType,
        ];
    }

    fixupFields() {
    }

    /**
     * Webhook ID to trigger notification
     */
    webhook_id: string;

}
